module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG32d2cf1ce35bbc763956c678bf5612fb.32d2cf1c.png";